module.exports = __webpack_public_path__ + "d4ed7f42982d536ecc52e70e8d889766.png";